import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import CustomButton from "../Utility/Button";
import tabClick from "../Utility/TabClick";
import {
  DashboardBox,
  DashboardChart,
  DashboardTable,
} from "../Utility/DashboardBox";
import { fetchToken } from "../../firebase";
import { registerFcmToken } from "../../services/users.service";
import { gteDashboardApi } from "../../services/dashboard.service";
function Dashboard() {

  const [dashboardObj, setdashboardObj] = useState("");
  const [totalProduct, settotalProduct] = useState(0);
  const [totalCustomer, settotalCustomer] = useState(0);
  const [totalOrder, settotalOrder] = useState(0);
  const [totalPending, settotalPending] = useState(0);
  const [totalComplete, settotalComplete] = useState(0);
  const [totalSale, settotalSale] = useState(0);
  const [totalReview, settotalReview] = useState(0);
  const [totalactiveCustomer, settotalactiveCustomer] = useState(0);
  const [totalSubscriber, settotalSubscriber] = useState(0);
  const [producrArr, setproducrArr] = useState([]);
  const getUserFcmToken = async () => {
    try {
      let temp = await fetchToken();
      let { data: res } = await registerFcmToken({ token: temp });
      if (res) {
        console.log(res);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handlseDashboard = async () => {
    try {
      let { data: res } = await gteDashboardApi();
      if (res.data) {
        setdashboardObj(res.data)
      }
    } catch (error) {
      console.error(error);
    }
  };



  useEffect(() => {
    console.log(dashboardObj,"dashboardObjdashboardObjsa")
    if(dashboardObj){
      settotalProduct(dashboardObj.totalProduct)
      settotalPending(dashboardObj.totalPendingOrder)
      settotalComplete(dashboardObj.totalCompleteOrder)
      settotalCustomer(dashboardObj.totalUser)
      settotalactiveCustomer(dashboardObj.totalActiveUser)
      settotalSale(dashboardObj?.totalRevenue[0]?.totalAmount)
      settotalOrder(dashboardObj.totalOrder)
      settotalReview(dashboardObj.totalOrder)
      settotalSubscriber(dashboardObj.totalSubscriber)
      setproducrArr(dashboardObj.topProductOrder)
    }
  
  }, [dashboardObj]);

  useEffect(() => {
    handlseDashboard();
    getUserFcmToken();
  }, []);

  // ================================================================================================================

  const [dashboardBox, setdashboardBox] = useState([
    {
      heading: "Total Product",
      today: totalProduct,
      week: "11",
      month: "11",
      year: "11",
    },
    {
      heading: "Total Customer",
      today: totalCustomer,
      week: "2",
      month: "2",
      year: "2",
    },
    {
      heading: "Total Order",
      today: totalOrder,
      week: "0",
      month: "0",
      year: "3",
    },
    {
      heading: "Total Pending ",
      today: totalPending,
      week: "0",
      month: "0",
      year: "3",
    },
    {
      heading: "Total Complete",
      today: totalComplete,
      week: "0",
      month: "0",
      year: "0",
    },
    {
      heading: "Total Sale",
      today: "₹ "+ totalSale,
      week: "₹ 0.00",
      month: "₹ 0.00",
      year: "₹ 5,167.81",
    },
    {
      heading: "Total Review",
      today: totalReview,
      week: "0",
      month: "0",
      year: "0",
    },
    // {
    //   heading: "Today Revenue",
    //   today: "₹ 0.00",
    //   week: "₹ 0.00",
    //   month: "₹ 0.00",
    //   year: "₹ 0.00",
    // },
    {
      heading: "Active Custome",
      today: totalactiveCustomer,
      week: "2",
      month: "2",
      year: "2",
    },
    {
      heading: "Total Subscrib",
      today: totalSubscriber  ,
      week: "2",
      month: "2",
      year: "2",
    },
  ]);

  const [filter, setfilter] = useState([
    {
      name: "Today",
      active: true,
      type: "today",
    },
    {
      name: "This Week",
      active: false,
      type: "week",
    },
    {
      name: "This Month",
      active: false,
      type: "month",
    },
    {
      name: "This Year",
      active: false,
      type: "year",
    },
  ]);

  const product_columns = [
    {
      name: "SL",
      selector: (row,index) => index+1,
      sortable: true,
      width:"10%"
    },
    {
      name: "Name",
      selector: (row) => row?.productObj?.name,
      
    },
   
    {
      name: "Total Order ",
      selector: (row) => row.count,
      width:"20%"
    },
  ];

  const product_data = [
    {
      sl: "1",
      name: "EYELINER SUPER BLACK",
      brand: "",
      sale: "0",
    },
    {
      sl: "2",
      name: "EYELINER SUPER BLACK",
      brand: "",
      sale: "0",
    },
    {
      sl: "3",
      name: "EYELINER SUPER BLACK",
      brand: "",
      sale: "0",
    },
    {
      sl: "4",
      name: "EYELINER SUPER BLACK",
      brand: "",
      sale: "0",
    },
    {
      sl: "5",
      name: "EYELINER SUPER BLACK",
      brand: "",
      sale: "0",
    },
    {
      sl: "6",
      name: "EYELINER SUPER BLACK",
      brand: "",
      sale: "0",
    },
    {
      sl: "7",
      name: "EYELINER SUPER BLACK",
      brand: "",
      sale: "0",
    },
    {
      sl: "8",
      name: "EYELINER SUPER BLACK",
      brand: "",
      sale: "0",
    },
    {
      sl: "9",
      name: "EYELINER SUPER BLACK",
      brand: "",
      sale: "0",
    },
  ];

  const quality_columns = [
    {
      name: "SL",
      selector: (row) => row.sl,
      sortable: true,
    },
    {
      name: "Category Name",
      selector: (row) => row.category,
    },
    {
      name: "Product Quantity",
      selector: (row) => row.quantity,
    },
  ];

  const quality_data = [
    {
      sl: "1",
      category: "EYELINER SUPER BLACK",
      quantity: "0",
      sortable: true,
    },
    {
      sl: "2",
      category: "EYELINER SUPER BLACK",
      quantity: "0",
      sortable: true,
    },
    {
      sl: "3",
      category: "EYELINER SUPER BLACK",
      quantity: "0",
      sortable: true,
    },
    {
      sl: "4",
      category: "EYELINER SUPER BLACK",
      quantity: "0",
      sortable: true,
    },
    {
      sl: "5",
      category: "EYELINER SUPER BLACK",
      quantity: "0",
      sortable: true,
    },
  ];
  const product_sale_columns = [
    {
      name: "SL",
      selector: (row) => row.sl,
      sortable: true,
    },
    {
      name: "Category Name",
      selector: (row) => row.category,
    },
    {
      name: "NO. OF SALE",
      selector: (row) => row.quantity,
    },
  ];

  const product_sale_data = [
    {
      sl: "1",
      category: "Nails",
      quantity: "0",
    },
    {
      sl: "2",
      category: "Eyes",
      quantity: "0",
    },
    {
      sl: "3",
      category: "Face",
      quantity: "0",
    },
    {
      sl: "4",
      category: "Lips",
      quantity: "0",
    },
    {
      sl: "5",
      category: "Nail polish",
      quantity: "0",
    },
    {
      sl: "6",
      category: "Perfect Finish box(Nail P...",
      quantity: "0",
    },
    {
      sl: "7",
      category: "Foundation",
      quantity: "0",
    },
    {
      sl: "8",
      category: "LIQUID SINDOOR",
      quantity: "0",
    },
    {
      sl: "9",
      category: "BEAUTY POP BOX LIP COLOR",
      quantity: "0",
    },
    {
      sl: "10",
      category: "LIPSTIC A & B",
      quantity: "0",
    },
  ];

  const coupon_sale_columns = [
    {
      name: "SL",
      selector: (row) => row.sl,
      sortable: true,
    },
    {
      name: "TYPE",
      selector: (row) => row.category,
    },
    {
      name: "COUPON",
      selector: (row) => row.quantity,
    },
    {
      name: "TOTAL DISCOUNT",
      selector: (row) => row.category,
    },
    {
      name: "NUM OF USES",
      selector: (row) => row.quantity,
    },
  ];

  const coupon_sale_data = ["No data available in table"];

  ChartJS.register(ArcElement, Tooltip, Legend);
  const productChartData = {
    labels: ["Published", "Total"],
    datasets: [
      {
        label: "Products",
        data: [dashboardObj?.totalActiveProduct, dashboardObj?.totalProduct],
        backgroundColor: ["rgba(54, 162, 235, 0.2)", "rgba(75, 192, 192, 0.2)"],
        borderColor: ["rgba(54, 162, 235)", "rgba(75, 192, 192)"],
        borderWidth: 1,
      },
    ],
  };
  const OrderChartData = {
    labels: ["Total", "Complete", "Processing", "pending"],
    datasets: [
      {
        label: "Orders Summary",
        data: [dashboardObj.totalOrder, dashboardObj.totalCompleteOrder, 0, dashboardObj.totalPendingOrder],
        backgroundColor: [
          "rgba(75, 192, 192, 0.2)", //green
          "rgba(54, 162, 235, 0.2)", //blue
          "rgba(255, 206, 86, 0.2)", //yellow
          "rgba(153, 102, 255, 0.2)", //purple
        ],
        borderColor: [
          "rgba(75, 192, 192)",
          "rgba(54, 162, 235)",
          "rgba(255, 206, 86)",
          "rgba(153, 102, 255)",
        ],
        borderWidth: 1,
      },
    ],
  };
  const GuestRegisterChart = {
    labels: ["In Cart", "Registered", "guest"],
    datasets: [
      {
        label: "Guest/Authorized Order Today",
        data: [dashboardObj?.totalUsercartOrder, dashboardObj?.totalAuthOrder, dashboardObj?.totalOrder],
        backgroundColor: [
          "rgba(75, 192, 192, 0.2)", //green
          "rgba(54, 162, 235, 0.2)", //blue
          "rgba(255, 206, 86, 0.2)", //yellow
        ],
        borderColor: [
          "rgba(75, 192, 192)",
          "rgba(54, 162, 235)",
          "rgba(255, 206, 86)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const TodayOrderChart = {
    labels: ["Total", "Complete", "Processing", "pending"],
    datasets: [
      {
        label: "Orders Summary",
        data: [20, 7, 10, 3],
        backgroundColor: [
          "rgba(75, 192, 192, 0.2)", //green
          "rgba(54, 162, 235, 0.2)", //blue
          "rgba(255, 206, 86, 0.2)", //yellow
          "rgba(153, 102, 255, 0.2)", //purple
        ],
        borderColor: [
          "rgba(75, 192, 192)",
          "rgba(54, 162, 235)",
          "rgba(255, 206, 86)",
          "rgba(153, 102, 255)",
        ],
        borderWidth: 1,
      },
    ],
  };

  // ================================================================================================================

  return (
    <main>
      <section className="mb-5">
        <div className="container-fluid">
          <div className="dashboard-head mb-3">
            <div className="d-flex align-items-center justify-content-between">
              <h5 className="blue-1 mb-0">Summary</h5>
              {/* <ul className="dashboard-filter filters">
                {filter.map((item, i) => {
                  return (
                    <li key={`${item.type}_${i}`}>
                      <CustomButton
                        navPills
                        btnName={item.name}
                        changeClass="filtering"
                        pillActive={item.active ? true : false}
                        data-type={item.type}
                        ClickEvent={() => tabClick(i, filter, setfilter)}
                      />
                    </li>
                  );
                })}
              </ul> */}
            </div>
          </div>
          {/* <div className="row">
            {dashboardBox.map((item, i) => {
              return (
                <div className="col-12 col-md-6 col-lg-4 col-xxl-3" key={i}>
                  <DashboardBox className="dashboard-summary">
                    <h5 className="blue-1">{item.heading}</h5>
                    <h4 className="text-dark mb-0">{item.today}</h4>
                  </DashboardBox>
                </div>
              );
            })}
          </div> */}
          <div className="row">
    
                <div className="col-12 col-md-6 col-lg-4 col-xxl-3" >
                  <DashboardBox className="dashboard-summary">
                    <h5 className="blue-1">   Total Product
                    </h5>
                    <h4 className="text-dark mb-0">{totalProduct}</h4>
                  </DashboardBox>
                </div>
                <div className="col-12 col-md-6 col-lg-4 col-xxl-3" >
                  <DashboardBox className="dashboard-summary">
                    <h5 className="blue-1">   Total Customer
                    </h5>
                    <h4 className="text-dark mb-0">{totalCustomer}</h4>
                  </DashboardBox>
                </div>

                <div className="col-12 col-md-6 col-lg-4 col-xxl-3" >
                  <DashboardBox className="dashboard-summary">
                    <h5 className="blue-1">  Total Order
                    </h5>
                    <h4 className="text-dark mb-0">{totalOrder}</h4>
                  </DashboardBox>
                </div>

                <div className="col-12 col-md-6 col-lg-4 col-xxl-3" >
                  <DashboardBox className="dashboard-summary">
                    <h5 className="blue-1">   Total Pending
                    </h5>
                    <h4 className="text-dark mb-0">{totalPending}</h4>
                  </DashboardBox>
                </div>

                <div className="col-12 col-md-6 col-lg-4 col-xxl-3" >
                  <DashboardBox className="dashboard-summary">
                    <h5 className="blue-1">   Total Complete
                    </h5>
                    <h4 className="text-dark mb-0">{totalComplete}</h4>
                  </DashboardBox>
                </div>

                   <div className="col-12 col-md-6 col-lg-4 col-xxl-3" >
                  <DashboardBox className="dashboard-summary">
                    <h5 className="blue-1">   Total Sale
                    </h5>
                    <h4 className="text-dark mb-0">{totalSale}</h4>
                  </DashboardBox>
                </div>   <div className="col-12 col-md-6 col-lg-4 col-xxl-3" >
                  <DashboardBox className="dashboard-summary">
                    <h5 className="blue-1">   Total Review
                    </h5>
                    <h4 className="text-dark mb-0">{totalReview}</h4>
                  </DashboardBox>
                </div>
                <div className="col-12 col-md-6 col-lg-4 col-xxl-3" >
                  <DashboardBox className="dashboard-summary">
                    <h5 className="blue-1">   Total Customer
                    </h5>
                    <h4 className="text-dark mb-0">{totalactiveCustomer}</h4>
                  </DashboardBox>
                </div>
                <div className="col-12 col-md-6 col-lg-4 col-xxl-3" >
                  <DashboardBox className="dashboard-summary">
                    <h5 className="blue-1">   Total Subscriber

                    </h5>
                    <h4 className="text-dark mb-0">{totalSubscriber}</h4>
                  </DashboardBox>
                </div>
          
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-md-6 col-xxl-4 mb-5">
              <DashboardChart>
                <h5 className="blue-1 mb-4">Products</h5>
                <Doughnut data={productChartData} />
              </DashboardChart>
            </div>
            <div className="col-12 col-md-6 col-xxl-4 mb-5">
              <DashboardChart>
                <h5 className="blue-1 mb-4">Orders Summary</h5>
                <Doughnut data={OrderChartData} />
              </DashboardChart>
            </div>
            <div className="col-12 col-md-6 col-xxl-4 mb-5">
              <DashboardChart>
                <h5 className="blue-1 mb-4">Guest/Authorized Order Today</h5>
                <Doughnut data={GuestRegisterChart} />
              </DashboardChart>
            </div>
            {/* <div className="col-12 col-md-6 col-xxl-4 mb-5">
              <DashboardChart>
                <h5 className="blue-1 mb-4">Today Order summary</h5>
                <Doughnut data={TodayOrderChart} />
              </DashboardChart>
            </div> */}
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-xxl-6 mb-5">
              <DashboardTable>
                <h5 className="blue-1 mb-4">Top 10 Product</h5>
                <DataTable columns={product_columns} data={producrArr} />
              </DashboardTable>
            </div>
            {/* <div className="col-12 col-xxl-6 mb-5">
              <DashboardTable>
                <h5 className="blue-1 mb-4">Category Wise Product Qty</h5>
                <DataTable columns={quality_columns} data={quality_data} />
                <div className="text-center mt-4 mb-2">
                  <CustomButton
                    isLink
                    noIcon
                    btnName="SEE ALL"
                    path="/"
                    small
                    roundedPill
                  />
                </div>
              </DashboardTable>
            </div> */}
            {/* <div className="col-12 col-xxl-6 mb-5">
              <DashboardTable>
                <h5 className="blue-1 mb-4">Category Wise Product Sale</h5>
                <DataTable
                  columns={product_sale_columns}
                  data={product_sale_data}
                />
                <div className="text-center mt-4 mb-2">
                  <CustomButton
                    isLink
                    noIcon
                    btnName="SEE ALL"
                    path="/"
                    small
                    roundedPill
                  />
                </div>
              </DashboardTable>
            </div> */}
            {/* <div className="col-12 col-xxl-6 mb-5">
              <DashboardTable>
                <h5 className="blue-1 mb-4">Coupon Wise Sale</h5>
                <DataTable
                  columns={coupon_sale_columns}
                  data={coupon_sale_data}
                />
              </DashboardTable>
            </div> */}
          </div>
        </div>
      </section>
    </main>
  );
}

export default Dashboard;
